import { NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Observable } from 'rxjs';

import { TokenService } from 'src/app/services/token/token.service';
import { UserInfoService } from 'src/app/services/auth-service/user-info-service';
import { EnvironmentConfigService } from 'src/app/services/environment-config-service/environment-config.service';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard {
	constructor(
		private authService: AuthService,
		public navCtrl: NavController,
		private _EnvironmentConfigService: EnvironmentConfigService,
		private router: Router,
	) {
	}

	canLoad():
		| boolean
		| UrlTree
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree> {
		// Return the result of allowLogin, ensuring it resolves before returning
		return this.allowLogin();
	}

	private async allowLogin(): Promise<boolean | UrlTree> {
		const appConfig = await this._EnvironmentConfigService.EnsureNetworkConfiguration("Login Guard");
		if (!appConfig) {
			return await this.navigateToLogin();
		}

		const userInfo = await UserInfoService.getUserInfo();

		if (!userInfo) {
			return await this.navigateToLogin();
		}

		
		// If we reach this point, the user is logged in
		return true;
	}

	async navigateToLogin(): Promise<UrlTree> {
		await this.authService.clearUserData(false);
		// Redirecting via UrlTree keeps this a single navigation. Kicking off navigateRoot here
		// and returning true let the guarded route load alongside the redirect, which raced and
		// left the app on an empty shell.
		return this.router.parseUrl('/welcome');
	}

	
}
